import STNavigateToCreateBoardButton from "../../assets/styles/atoms/navigateToCreateBoardButton.module.scss";
import STButton from "../../assets/styles/atoms/button.module.scss";

type NavigateToCreateBoardButtonProps = {
  title?: string;
  onClick: () => void;
  className?: string;
};

const NavigateToCreateBoardButton = (
  props: NavigateToCreateBoardButtonProps
) => {
  const { title = "投稿する", onClick, className = "" } = props ?? {};
  return (
    <button
      className={`${STNavigateToCreateBoardButton.createBoardButton} ${STButton.primary} ${className}`}
      onClick={onClick}
    >
      {title}
    </button>
  );
};

export default NavigateToCreateBoardButton;
